export const coachScheduleKeys = {
  all: ['coachSchedule'] as const,
  detail: (coachId: string) => [...coachScheduleKeys.all, coachId] as const,
};
